import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import LazyLoad from 'react-lazyload';
import SearchResultKickers from './search-result-kickers';

export default function SearchResult({ searchResult }) {
  const momentStartTime = moment.utc(searchResult.published);
  const dateT = momentStartTime.tz('America/New_York').format('MMMM D, YYYY');

  const momentConfStartTime = moment.utc(searchResult.start_date);
  const dateC = momentConfStartTime.tz('America/New_York').format('MMMM D, YYYY');

  const momentConfEndTime = moment.utc(searchResult.end_date);
  const dateEndC = momentConfEndTime.tz('America/New_York').format('MMMM D, YYYY');

  const image = searchResult?.header_image ? searchResult.header_image : searchResult.teaser_image;
  const confLocation = searchResult.location ? (
    <p className="date">
      {searchResult.location}
      ,&nbsp;
    </p>
  ) : null;

  const authorInfo = searchResult.author ? (
    <div className="author__container">
      <a className="author" href={searchResult.author_url}>
        <LazyLoad once>
          <img src={searchResult.author_headshot_url} alt={searchResult.author} />
        </LazyLoad>
        {searchResult.author}
      </a>
    </div>
  ) : null;

  const authorInfoPresentation = searchResult.external_authors && searchResult.type === 'slide' ? (
    <div className="author__container">
      <p className="external_author_title">Presenter: &nbsp;</p>
      <p className="external_author">
        {searchResult.external_authors.join(', ')}
      </p>
    </div>
  ) : null;

  const isMemberCaseOrPartnerContent = image || (searchResult.type !== 'case_study' && searchResult.type !== 'basic_html');

  const imageResults = searchResult.subtype !== 'Industry News' && isMemberCaseOrPartnerContent ? (
    <div className="left-container">
      <a href={searchResult.url}>
        <LazyLoad once>
          <img src={image} alt={searchResult.title} />
        </LazyLoad>
      </a>
    </div>
  ) : null;

  const conferenceStartDate = searchResult.start_date ? (
    <p className="date">
      {dateC}
      &nbsp;
      -&nbsp;
    </p>
  ) : null;

  const conferenceEndDate = searchResult.end_date ? (
    <p className="date">
      {dateEndC}
    </p>
  ) : null;

  const date = conferenceStartDate === null && searchResult.published ? (
    <p className="date">{dateT}</p>
  ) : null;

  console.log(searchResult);

  return (
    <div className={`search-page__results ${searchResult.type}`}>
      { imageResults }
      <div className="right-container">
        <SearchResultKickers item={searchResult} />
        <h2 className="search-page__title-result">
          <a href={searchResult.url}>{searchResult.title}</a>
        </h2>
        <div className="search-page__author-date">
          {authorInfo}
          {authorInfoPresentation}
          {date}
          {confLocation}
          {conferenceStartDate}
          {conferenceEndDate}
        </div>
      </div>
    </div>
  );
}

SearchResult.propTypes = {
  searchResult: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    published: PropTypes.string,
    author: PropTypes.string,
    subtype: PropTypes.string,
    external_authors: PropTypes.string,
    author_url: PropTypes.string,
    end_date: PropTypes.string,
    start_date: PropTypes.string,
    location: PropTypes.string,
    author_headshot_url: PropTypes.string,
    url: PropTypes.string,
    header_image: PropTypes.string,
    teaser_image: PropTypes.string,
  }).isRequired,
};
